import { WORKFLOW_LIMIT } from 'automation-ui-template/constants/Limits';
import * as Scopes from 'automation-ui-template/constants/Scopes';
// TODO - @mlegocki: replace `getWorkflowLimitInfo` from "automation-ui-template/static-1.36134/js/utils/limitUtils" with this
export const useWorkflowLimitInfo = ({
  getLimit,
  hasScope,
  totalWorkflowCount
}) => {
  const hasEnterpriseWorkflowLimit = hasScope(Scopes.WORKFLOWS_ENTERPRISE_LIMITS);
  const workflowLimit = getLimit(WORKFLOW_LIMIT);
  const isWorkflowLimitReached = totalWorkflowCount >= workflowLimit;
  return {
    hasEnterpriseWorkflowLimit,
    isWorkflowLimitReached,
    workflowLimit
  };
};